import { apiFetch } from '$lib/api/helpers';
import type { Project, ProjectRequest } from '$lib/types/project';

const PATH = '/projects/';

export async function fetchProjects() {
	return apiFetch<Array<Project>>(PATH);
}

export async function fetchProjectById(id: number) {
	return apiFetch<Project>(`${PATH}${id}/`);
}

export async function deleteProject(id: number) {
	return apiFetch<void>(`${PATH}${id}/`, { method: 'DELETE' });
}

export async function createProject(projectRequest: ProjectRequest) {
	return apiFetch<Project>(PATH, { method: 'POST', body: JSON.stringify(projectRequest) });
}

export async function updateProject(id: number, projectRequest: ProjectRequest) {
	return apiFetch<Project>(`${PATH}${id}/`, {
		method: 'PUT',
		body: JSON.stringify(projectRequest)
	});
}

export async function patchProject(id: number, projectRequest: Partial<ProjectRequest>) {
	return apiFetch<Project>(`${PATH}${id}/`, {
		method: 'PATCH',
		body: JSON.stringify(projectRequest)
	});
}

export async function exportProjectBOM(projectId: number) {
	return apiFetch<unknown>(`/bom/project_bom/?project_id=${projectId}`);
}

export async function exportProjectBOMXLS(projectId: number) {
	return apiFetch<string>(`/bom/project_bom_xlsx/?project_id=${projectId}`, { format: 'xlsx' });
}

export async function exportProjectBOQJSON(projectId: number) {
	return apiFetch<unknown>(`/bom/project_boq/?project_id=${projectId}&format=json`);
}

export async function exportProjectBOQCSV(projectId: number) {
	return apiFetch<string>(`/bom/project_boq/?project_id=${projectId}&format=csv`, { format: 'blob' });
}

export type SendToQuoteResult = {
	url?: string;
	unresolved?: string[];
	created_products?: string[];
	warning?: string | null;
};

export async function sendProjectToQuote(projectId: number) {
	return apiFetch<SendToQuoteResult>(`${PATH}${projectId}/send_to_quote/`, { method: 'POST' });
}
